var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"settlement-summary-chip"},[_vm._t("prefix"),_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("default",function(){return [_c('strong',[_vm._v(_vm._s(_vm.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }